export default "<editor [init]=\"init\" [ngModel]=\"value\" (ngModelChange)=\"valueChange.emit($event)\"></editor>\n"